import { Link } from "react-router-dom";

interface RelatedPage {
  path: string;
  label: string;
}

const SEORelatedPages = ({ pages }: { pages: RelatedPage[] }) => {
  if (!pages.length) return null;

  return (
    <nav className="mt-16 pt-8 border-t border-border">
      <h2 className="font-display text-lg font-bold mb-4 text-foreground">Смотрите также</h2>
      <ul className="space-y-2 text-sm">
        {pages.map((p) => (
          <li key={p.path}>
            <Link to={p.path} className="text-primary hover:underline">
              {p.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SEORelatedPages;
